export const navigation = [
  { name: "Home", path: "/" },
  { name: "About us", path: "/about" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Join us", path: "/join" },
  { name: "Support us", path: "/support" },
  { name: "Contact", path: "/contact" },
];
